// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wGHR","footer":"styles_footer__S0Q-c"};